<template lang="pug">
  .notification-assigned
    router-link(:to="{name: routeName, params: { boardSlug: notification.meta.feature.board.slug, featureSlug: notification.meta.feature.slug } }")
      .row.center
        .col.notification-avatar
          UserAvatar(:user="notification.meta.user", :icon="['fad', 'user']")
        .col.max
          p {{ notification.description }}
</template>

<script>

export default {
  name: 'NotificationAssigned',
  props: {
    notification: Object
  },
  mounted () {
  },
  computed: {
    routeName () {
      return this.$route.meta.member || (this.$route.name.indexOf('Admin') > -1) ? 'AdminFeature' : 'PublicFeature'
    }
  }
}
</script>

<style scoped lang="stylus">
</style>
